import yup from 'config/yup'

export default yup.object().shape({
  name: yup.string().required(),
  description: yup.string().required(),
  price: yup.number().typeError('Campo inválido').required(),
  category_id: yup.number().required()
})
